module.exports = __webpack_public_path__ + "img/N121-1-EN.db8df5e5.png";